import Vue from 'vue';
import Vuex from 'vuex';

import quotes from 'greenmotion-shared/vuex/quotes';
import search from 'greenmotion-shared/vuex/search';
import errors from 'greenmotion-shared/vuex/errors';
import users from 'greenmotion-shared/vuex/users';
import axios from 'axios';
import { HTTP_CONFIG } from 'greenmotion-shared/common/http';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    key: 'portal-booking',
    reducer: state => {
        let reducedState = {
            userToken: state.userToken,
            search: {
                search: {
                    currency: state.search.search.currency,
                    driverAge: state.search.search.driverAge,
                    guestToken: state.search.search.guestToken,
                },
            },
        };
        if (window.localStorage !== undefined) {
            HTTP_CONFIG(
                reducedState.search.search.currency,
                reducedState.search.search.guestToken,
                reducedState.userToken
            );
        }
        return reducedState;
    },
});

const debug = process.env.NODE_ENV !== 'production';

quotes.state.createDirect = false;

export default new Vuex.Store({
    modules: {
        quotes,
        search,
        errors,
        users,
    },
    state: {
        userToken: null,
    },
    mutations: {
        setUserToken(state, token) {
            state.userToken = token;
        },
    },
    actions: {
        refreshToken({ commit }) {
            var http = axios.create({
                baseURL: `${location.protocol}//${location.hostname}:${location.port}`,
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
            });

            http.get(`user/token`).then(response => {
                commit('setUserToken', response.data.access_token);
            });
        },
    },
    strict: debug,
    plugins: [vuexLocal.plugin],
});



// WEBPACK FOOTER //
// ./resources/scripts/portal/apps/shared/vuex/store.js